// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__13-N0","title":"Info_title__10HK6","selects":"Info_selects__23imM","requiredAsterisk":"Info_requiredAsterisk__3JwAH"};